(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pr-gift-card"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('pr-gift-card'))customElements.define('pr-gift-card',class extends HTMLElement{
 connectedCallback(){if(this.initialized)return;this.initialized=true;this.addEventListener('change',event=>{if(event.target.matches('input[name="id"]'))this.querySelectorAll('[data-gift-price]').forEach(el=>el.textContent=event.target.dataset.money);});}
});

  } catch(e) { console.error(e); }
})();
})();
